// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__2-_aB","expandIcon":"AccordionButton_expandIcon__3lo2w","expanded":"AccordionButton_expanded__3ojBM"};